module.exports = __webpack_public_path__ + "img/title-text-en.f9b30dd2.png";